import { render, staticRenderFns } from "./PartySubnav.vue?vue&type=template&id=c45c9e62"
import script from "./PartySubnav.vue?vue&type=script&lang=js"
export * from "./PartySubnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports